module.exports = __webpack_public_path__ + "img/FPT25.3aadeeca.svg";